// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InternalendpointsModelDetails
 */
export interface InternalendpointsModelDetails {
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  auraInstanceId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  consoleUserId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  databaseUsername?: string;
  /**
   *
   * @type {object}
   * @memberof InternalendpointsModelDetails
   */
  graphSchema?: object;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  id?: string;
  /**
   *
   * @type {object}
   * @memberof InternalendpointsModelDetails
   */
  modelInfo?: object;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  modelType?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  projectId?: string;
  /**
   * PRIVATE / PROJECT
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  publishState?: string;
  /**
   * java / python
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  runtimeOrigin?: string;
  /**
   *
   * @type {number}
   * @memberof InternalendpointsModelDetails
   */
  sizeInBytes?: number;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelDetails
   */
  storageLocation?: string;
  /**
   *
   * @type {object}
   * @memberof InternalendpointsModelDetails
   */
  trainConfig?: object;
}

/**
 * Check if a given object implements the InternalendpointsModelDetails interface.
 */
export function instanceOfInternalendpointsModelDetails(
  value: object,
): value is InternalendpointsModelDetails {
  return true;
}

export function InternalendpointsModelDetailsFromJSON(
  json: any,
): InternalendpointsModelDetails {
  return InternalendpointsModelDetailsFromJSONTyped(json, false);
}

export function InternalendpointsModelDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsModelDetails {
  if (json == null) {
    return json;
  }
  return {
    auraInstanceId:
      json['aura_instance_id'] == null ? undefined : json['aura_instance_id'],
    consoleUserId:
      json['console_user_id'] == null ? undefined : json['console_user_id'],
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    databaseUsername:
      json['database_username'] == null ? undefined : json['database_username'],
    graphSchema:
      json['graph_schema'] == null ? undefined : json['graph_schema'],
    id: json['id'] == null ? undefined : json['id'],
    modelInfo: json['model_info'] == null ? undefined : json['model_info'],
    modelType: json['model_type'] == null ? undefined : json['model_type'],
    name: json['name'] == null ? undefined : json['name'],
    projectId: json['project_id'] == null ? undefined : json['project_id'],
    publishState:
      json['publish_state'] == null ? undefined : json['publish_state'],
    runtimeOrigin:
      json['runtime_origin'] == null ? undefined : json['runtime_origin'],
    sizeInBytes:
      json['size_in_bytes'] == null ? undefined : json['size_in_bytes'],
    storageLocation:
      json['storage_location'] == null ? undefined : json['storage_location'],
    trainConfig:
      json['train_config'] == null ? undefined : json['train_config'],
  };
}

export function InternalendpointsModelDetailsToJSON(
  json: any,
): InternalendpointsModelDetails {
  return InternalendpointsModelDetailsToJSONTyped(json, false);
}

export function InternalendpointsModelDetailsToJSONTyped(
  value?: InternalendpointsModelDetails | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aura_instance_id: value['auraInstanceId'],
    console_user_id: value['consoleUserId'],
    created_at: value['createdAt'],
    database_username: value['databaseUsername'],
    graph_schema: value['graphSchema'],
    id: value['id'],
    model_info: value['modelInfo'],
    model_type: value['modelType'],
    name: value['name'],
    project_id: value['projectId'],
    publish_state: value['publishState'],
    runtime_origin: value['runtimeOrigin'],
    size_in_bytes: value['sizeInBytes'],
    storage_location: value['storageLocation'],
    train_config: value['trainConfig'],
  };
}
